import { render, staticRenderFns } from "./ManageBank.vue?vue&type=template&id=7b742fc0"
import script from "./ManageBank.vue?vue&type=script&lang=js"
export * from "./ManageBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports